import { render } from "./recordDetails.vue?vue&type=template&id=44fc64d6&scoped=true"
import script from "./recordDetails.vue?vue&type=script&lang=js"
export * from "./recordDetails.vue?vue&type=script&lang=js"

import "./recordDetails.vue?vue&type=style&index=0&id=44fc64d6&lang=less&scoped=true"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44fc64d6"]])

export default __exports__